export function formatPercent(value?: number, digits: number = 0): string {
  if (value === undefined || value === null) {
    return '';
  }
  const increasedValue = value * 100;
  return increasedValue.toFixed(digits);
}
